import React from "react";

/**
 * Elena Pykhova — official wordmark logo.
 * Light variant (default) for cream backgrounds.
 * Dark variant for the footer (black background).
 */
export const Logo = ({ variant = "dark", compact = false, className = "" }) => {
  const src =
    variant === "light"
      ? "/images/logo-stacked-dark.png" // recoloured for dark backgrounds
      : "/images/logo-stacked.png"; // black + teal on light backgrounds

  return (
    <a
      href="#top"
      aria-label="Elena Pykhova — The Op Risk Company — home"
      data-testid="brand-logo"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={src}
        alt="Elena Pykhova — The Op Risk Company"
        className={`block w-auto ${compact ? "h-12" : "h-16 md:h-20"}`}
        draggable="false"
      />
    </a>
  );
};

export default Logo;
